import { useState } from "react";
import { toast } from "sonner";
import { FileDown } from "lucide-react";
import { api } from "@/lib/api";

export const ChecklistMagnet = ({ source = "checklist" }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/newsletter", { email, source });
      toast.success("Checklist sent. Check your inbox.");
      setDone(true);
    } catch {
      toast.error("Something broke. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="checklist-magnet" className="border border-white/15 p-8 lg:p-12 grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
      <div>
        <div className="flex items-center gap-3">
          <FileDown size={22} className="text-white/60" />
          <p className="font-mono-label text-white/40">FREE DOWNLOAD</p>
        </div>
        <h3 className="font-display text-2xl lg:text-4xl mt-4">THE FIRST RUN CLUB CHECKLIST.</h3>
        <p className="text-white/50 text-sm mt-3 max-w-md">
          Nine questions to ask before you go, the green flags and red flags that matter, what to say when you know nobody, and a rubric to score any club yourself. Five pages, zero fluff.
        </p>
      </div>
      {done ? (
        <div data-testid="checklist-success" className="border border-white/25 p-6">
          <p className="font-mono-label text-white/80">✓ SENT. CHECK YOUR INBOX.</p>
          <a href="/downloads/first-run-club-checklist.pdf" target="_blank" rel="noopener noreferrer" data-testid="checklist-download-link" className="btn-invert inline-block mt-4 font-mono-label bg-white text-ink border border-white px-5 py-3 hover:bg-transparent hover:text-white">
            OR DOWNLOAD IT NOW
          </a>
        </div>
      ) : (
        <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3" data-testid="checklist-form">
          <input
            data-testid="checklist-email-input"
            type="email" required placeholder="EMAIL ADDRESS"
            value={email} onChange={(e) => setEmail(e.target.value)}
            className="flex-1 bg-transparent border-b border-white/30 py-3 text-sm placeholder:text-white/30 focus:border-white transition-colors duration-200"
          />
          <button type="submit" disabled={loading} data-testid="checklist-submit" className="btn-invert font-mono-label bg-white text-ink border border-white px-6 py-3.5 hover:bg-transparent hover:text-white disabled:opacity-50 shrink-0">
            {loading ? "SENDING..." : "SEND ME THE CHECKLIST"}
          </button>
        </form>
      )}
    </div>
  );
};
